import { useEffect } from 'react';

import { GoogleTagManager, sendGTMEvent } from '@next/third-parties/google';

import type { ClientUser } from '~/service/user';

export interface GtmProps {
  user: ClientUser | undefined;
}

export function Gtm({ user }: GtmProps) {
  useEffect(() => {
    if (!user) {
      return;
    }
    sendGTMEvent({
      traffic_type: user.type,
    });
  }, [user]);

  return (
    <GoogleTagManager
      gtmId="GTM-TS43CMS"
      // set default consent on init
      dataLayer={{
        1: 'consent',
        2: 'default',
        3: {
          ad_storage: 'granted',
          analytics_storage: 'granted',
        },
      }}
    />
  );
}
